import { render } from "./confirm-bundle.template.html?vue&type=template&id=228d51b6&scoped=true"
import script from "./ConfirmBundle.vue?vue&type=script&lang=ts"
export * from "./ConfirmBundle.vue?vue&type=script&lang=ts"

import "./ConfirmBundle.vue?vue&type=style&index=0&id=228d51b6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-228d51b6"

export default script